import {
  AccommodationPage,
  AccommodationsPage,
  BookingsPage,
  ErrorPage,
  HomeCaretakersPage,
  HomePage,
  IcalIntegrationsPage,
  PricingPage,
} from "../pages";
import BookingsCabinPage from "../pages/BookingsPage/BookingsCabinPage";
import BookingsBookingPage from "../pages/BookingsPage/BookingsBookingPage";
import PricingCabinPage from "../pages/PricingPage/PricingCabinPage";
import ReportsPage from "../pages/ReportsPage";
import DocumentsPage from "../pages/DocumentsPage";
import SupportPage from "../pages/SupportPage";
import UserPage from "../pages/UserPage";
import React from "react";
import FeedBackDetails from "../pages/FeedBacks/FeedBackDetails";
import FeedBacks from "../pages/FeedBacks/FeedBacks";
import SupportSearchPage from "../pages/SupportPage/SupportSearchPage";
import SettlementReport from "../pages/ReportsPage/SettlementReport";
import AccountSelectionPage from "../pages/AccountSelectionPage/AccountSelectionPage";
import { Navigate } from "react-router-dom";

const AppRoutes = [
  {
    path: "/",
    element: <HomePage />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/index.html",
    element: <Navigate to="/" replace />,
  },
  {
    path: "select-account",
    element: <AccountSelectionPage />,
  },
  {
    path: "home-caretakers",
    element: <HomeCaretakersPage />,
  },
  {
    path: "accommodations",
    element: <AccommodationsPage />,
  },
  {
    path: "accommodations/modify/:accommodationId",
    element: <AccommodationPage />,
  },
  {
    path: "bookings",
    element: <BookingsPage />,
  },
  {
    path: "bookings/cabin/:accommodationId",
    element: <BookingsCabinPage />,
  },
  {
    path: "bookings/booking/:bookingId",
    element: <BookingsBookingPage />,
  },
  {
    path: "feedbacks/details/:feedBackId",
    element: <FeedBackDetails />,
  },
  {
    path: "feedbacks/",
    element: <FeedBacks />,
  },
  {
    path: "pricing",
    element: <PricingPage />,
  },
  {
    path: "ical-integrations",
    element: <IcalIntegrationsPage />,
  },
  {
    path: "pricing/modify/:accommodationId",
    element: <PricingCabinPage />,
  },
  {
    path: "reports",
    element: <ReportsPage />,
  },
  {
    path: "reports/settlementreport",
    element: <SettlementReport />,
  },
  {
    path: "documents",
    element: <DocumentsPage />,
  },
  {
    path: "support",
    element: <SupportPage />,
  },
  {
    path: "support/search",
    element: <SupportSearchPage />,
  },
  {
    path: "userDetails",
    element: <UserPage />,
  },
];

export default AppRoutes;
